// extracted by mini-css-extract-plugin
export default {"btn":"Header_btn__IaL-s","active":"Header_active__or8T6","flexContainer":"Header_flexContainer__bo00-","langbtn":"Header_langbtn__7MA+3","currencybtn":"Header_currencybtn__psHcz"};